// extracted by mini-css-extract-plugin
export default {"targeted-muscles":"TargetedMuscles_targeted-muscles__5rB0L"};